import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AsyncPipe, NgForOf, NgIf, SlicePipe } from '@angular/common';
import { AnnouncementsCollectionComponent } from '../announcements-collection.component';
import { selectAnnouncements } from '@redux/announcements.effects';
import { AnnouncementsService } from '../../services/announcements.service';

@Component({
  selector: 'app-announcements-dashboard',
  standalone: true,
  imports: [RouterLink, AsyncPipe, NgIf, NgForOf, SlicePipe],
  providers: [AnnouncementsService],
  templateUrl: './announcements-dashboard.component.html',
  styleUrls: ['./announcements-dashboard.component.scss'],
})
export class AnnouncementsDashboardComponent extends AnnouncementsCollectionComponent {
  // Add selector for unread count
  unreadCount$ = this.store.select(selectAnnouncements.unreadCount);
}
